module.exports = __webpack_public_path__ + "img/left_BG.f2c7c420.png";